import React from "react";
import * as S from "./styles";

export const Ambassadors: React.FC = () => {
  return (
    <>
      <S.Container>
        <S.GroupAmbassadors>
          <h2>
            Embaixadores
            <br />
            <span>Orthopride</span>
          </h2>
        </S.GroupAmbassadors>
        <S.GroupCards>
          <S.Card>
            <S.FaceCaio alt="Caio Castro" />
            <h2>Caio Castro</h2>
            <p>Ator e piloto automobilístico</p>
          </S.Card>
          <S.Card>
            <S.FaceMedina alt="Medina" />
            <h2>Gabriel Medina</h2>
            <p>
              Surfista
              <br />
              Tricampeão mundial
            </p>
          </S.Card>
          <S.Card>
            <S.FaceLucas alt="Lucas Chumbo" />
            <h2>Lucas Chumbo</h2>
            <p>
              Surfista de Ondas Gigantes
              <br /> 4x Nazare Tow Challenge
            </p>
          </S.Card>
          {/* <S.Card>
            <S.FaceMichele alt="Michelle Bouillons" />
            <h2>
              Michelle
              <br />
              Bouillons
            </h2>
            <p>
              Surfista de Ondas Gigantes
              <br /> Modelo e Apresentadora de TV
            </p>
          </S.Card> */}
          <S.Card>
            <S.FaceFink alt="Lucas Fink" />
            <h2>Lucas Fink</h2>
            <p>5x campeão mundial Skimboard de Ondas Gigantes</p>
          </S.Card>
          {/* <S.Card>
            <S.FaceIan alt="Ian Consenza" />
            <h2>Ian Consenza</h2>
            <p>
              Surfista de Ondas Gigantes
              <br /> Piloto PWC
            </p>
          </S.Card> */}
        </S.GroupCards>
      </S.Container>
    </>
  );
};
